import {useFormContextRHF} from "@pg-design/rhf-components-module";

import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {HomeMatchPreferencesSurveyCompletionDatePills} from "../home_match_preferences_survey/fields/HomeMatchPreferencesSurveyCompletionDatePills";

export const HomeMatchPreferencesWizardCompletionDateStep = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const constructionEndDate = watch("constructionEndDate");

    return (
        <HomeMatchPreferencesSurveyCompletionDatePills
            centered
            onChange={(value) => setValue("constructionEndDate", value, {shouldDirty: true})}
            value={constructionEndDate}
        />
    );
};
import {useFormContextRHF} from "@pg-design/rhf-components-module";

import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {HomeMatchPreferencesSurveyCompletionDatePills} from "../home_match_preferences_survey/fields/HomeMatchPreferencesSurveyCompletionDatePills";

export const HomeMatchPreferencesWizardCompletionDateStep = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const constructionEndDate = watch("constructionEndDate");

    return (
        <HomeMatchPreferencesSurveyCompletionDatePills
            centered
            onChange={(value) => setValue("constructionEndDate", value, {shouldDirty: true})}
            value={constructionEndDate}
        />
    );
};
